// extracted by mini-css-extract-plugin
export default {"tableHeadCell":"fuelReportTable_tableHeadCell__-F4t2","tableRow":"fuelReportTable_tableRow__s3zOi","tableBodyCell":"fuelReportTable_tableBodyCell__h-eAv"};